/* ==== lodar-xh.js ==== */
try{
/* L'ODAR Maison: Die Tuer geht auf, die Kamera geht ins Haus, dort steht die 3D-Bar.
   Laeuft nach three.js und vor lodar-x3d.js. */
(function(){
  var hero = document.querySelector('.x-hero'), wrap = document.getElementById('stageWrap'), stage = document.getElementById('stage');
  if(!hero || !wrap || !stage) return;
  window.LODAR_ROOM = true;
  /* v22 (fluessig): derselbe Film, leichter und mit dem Index am Anfang (2,2 statt 4,0 MB), aus dem Theme (theme.liquid setzt
     LODAR_HOUSE_VIDEO). Laedt er nicht, kommt einmal der bisherige Film; erst danach wie bisher das Standbild. */
  var OLD = 'https://cdn.shopify.com/s/files/1/0960/3907/6173/files/lodar-haus.mp4';
  var SRC = window.LODAR_HOUSE_VIDEO || (window.LODAR_ASSET_BASE ? window.LODAR_ASSET_BASE + 'lodar-haus-web.mp4' : OLD);
  var alt = SRC !== OLD ? OLD : '', gen = 0;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var seen = false; try{ seen = sessionStorage.getItem('lodar-house') === '1'; }catch(e){}
  /* v18 (B4): Datensparen (Save-Data) oder 2G: kein Haus-Film, gleich das Standbild mit der 3D-Bar (dieselbe Regel wie im Kopf-Skript und in lodar-v18.js) */
  try{ var cn = navigator.connection; if(cn && (cn.saveData || /2g/.test(cn.effectiveType || ''))) seen = true; }catch(e){}

  /* 1. Die 3D-Bar wird durchsichtig, damit der Raum dahinter sichtbar ist */
  if(typeof THREE !== 'undefined' && THREE.WebGLRenderer){
    var R = THREE.WebGLRenderer;
    var W = function(p){
      p = p || {};
      var mine = p.canvas === stage;
      if(mine) p.alpha = true;
      var r = new R(p);
      if(mine){ var sc = r.setClearColor.bind(r); r.setClearColor = function(c){ sc(c, 0); }; }
      return r;
    };
    W.prototype = R.prototype; THREE.WebGLRenderer = W;
  }

  /* 2. Der Raum: das Video vom Haus, hinter der Bar */
  /* Standbild vom Raum: ist immer da, auch wenn das Video nicht laeuft (Stromsparmodus, langsames Netz) */
  var still = document.createElement('div'); still.className = 'xh-still';
  wrap.insertBefore(still, wrap.firstChild);
  var v = document.createElement('video');
  v.className = 'xh-room'; v.muted = true; v.defaultMuted = true; v.setAttribute('muted', ''); v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', ''); v.preload = 'none';
  wrap.insertBefore(v, still.nextSibling);
  /* der Film laedt erst, wenn er wirklich laufen wird (nach dem gepufferten Intro oder beim Eintreten) */
  function arm(){ if(!v.getAttribute('src')){ v.src = SRC; v.preload = 'auto'; } }
  hero.classList.add('xh-on');

  /* 3. Ablauf: erst ins Haus gehen, dann fliegt die Kamera zur Bar */
  var released = false, playing = false;
  function release(){
    if(released) return; released = true;
    hero.classList.add('xh-in');
    try{ sessionStorage.setItem('lodar-house', '1'); }catch(e){}
    window.__lodarIntroDone = true;
    try{ var ev = new Event('lodar:intro'); ev.__house = true; window.dispatchEvent(ev); }catch(e){}
  }
  function showLastFrame(){ hero.classList.remove('xh-tap'); hero.classList.add('xh-static'); release(); }
  /* Stromsparmodus / Autoplay gesperrt: geschlossene Tuer, der Gast tippt auf "Eintreten" */
  var door = null;
  function askTap(){
    if(released) return;
    hero.classList.remove('xh-copy');
    if(!door){
      door = document.createElement('div'); door.className = 'xh-door';
      door.innerHTML = '<button type="button" class="xh-enter"><span>Eintreten</span></button>';
      wrap.appendChild(door);
      /* v18: "Eintreten" in der gewaehlten Sprache */
      if(window.LODAR_I18N_ADD) window.LODAR_I18N_ADD(door);
      door.addEventListener('click', function(){
        if(!tryPlay(showLastFrame)) return;
        hero.classList.remove('xh-tap');
      });
    }
    hero.classList.add('xh-tap');
  }
  /* ein Tippen im Intro schaltet das Haus-Video gleich mit frei */
  window.__lodarUnlockHouse = function(){
    if(released || seen || reduce) return;
    arm();
    try{ var q = v.play(); if(q && q.then) q.then(function(){ if(!playing){ v.pause(); try{ v.currentTime = 0; }catch(e){} } }).catch(function(){}); }catch(e){}
  };
  /* das Signal "Intro fertig" halten wir an, bis die Tuer offen und die Kamera drinnen ist */
  window.addEventListener('lodar:intro', function(e){
    if(e.__house) return;
    e.stopImmediatePropagation();
    enter();
  });
  var introAlreadyDone = !!window.__lodarIntroDone;
  window.__lodarIntroDone = false;

  function enter(){
    if(playing || released) return;
    if(seen || reduce){ showLastFrame(); return; }
    arm();
    playing = true;
    hero.classList.add('xh-play');
    try{ v.currentTime = 0; }catch(e){}
    if(!tryPlay(askTap)) return;
    /* startet das Video nach 15 s nicht (sehr langsames Netz), gehen wir direkt ins Haus */
    var started = false; v.addEventListener('playing', function(){ started = true; hero.classList.remove('xh-tap'); }, {once:true});
    setTimeout(function(){ if(!released && !started && !hero.classList.contains('xh-tap')) showLastFrame(); }, 15000);
  }
  /* v18: spaetestens 20 s nach dem Start ist die Bar da, und bleibt der Film unterwegs 4 s haengen, geht es direkt ins Haus
     (der Film dauert rund 4 s; der Hero-Text erscheint wie in v17 erst im Haus, Owner-Vorrang 20.10.) */
  var capT = 0, stallT = 0;
  v.addEventListener('playing', function(){
    clearTimeout(stallT);
    if(!playing || released) return;
    if(!capT) capT = setTimeout(function(){ if(!released) showLastFrame(); }, 20000);
  });
  v.addEventListener('waiting', function(){
    clearTimeout(stallT);
    if(!playing || released) return;
    stallT = setTimeout(function(){ if(!released) showLastFrame(); }, 4000);
  });
  v.addEventListener('ended', release);
  v.addEventListener('error', function(){ if(!v.getAttribute('src') || !v.error) return; if(!useAlt()) showLastFrame(); });
  /* v22: Ersatz, wenn der neue Film nicht laedt (einmal der bisherige Film, solange von ihm noch nichts geladen ist und wir
     noch nicht im Haus sind; ein Fehler mitten im Film geht wie bisher zum Standbild). Eine Absage von play(), die nur vom
     Wechsel kommt, zaehlt nicht (gen); "nicht unterstuetzt" heisst: Film laedt nicht, also Ersatz. */
  function tryPlay(fail){
    var g = gen, q; try{ q = v.play(); }catch(e){ fail(); return false; }
    if(q && q.catch) q.catch(function(err){ if(g !== gen) return; if(err && err.name === 'NotSupportedError' && useAlt()) return; fail(); });
    return true;
  }
  function useAlt(){
    if(!alt || released || v.readyState > 0) return false;
    var u = alt; alt = ''; gen++;
    v.src = u; v.preload = 'auto';
    if(playing && !hero.classList.contains('xh-tap')) tryPlay(askTap);
    return true;
  }
  if(!seen && !reduce){
    if(window.__lodarIntroBuffered) arm();
    else window.addEventListener('lodar:introbuffered', function(){ if(!seen && !reduce) arm(); }, {once:true});
  }
  if(introAlreadyDone) enter();
})();

}catch(e){console.error("[lodar-xh.js]",e)}
;
/* ==== v24 Haus-Fuellung (Handy) ==== */
try{
/* Owner 23.10.2026: auf dem Handy war die Flaeche unter dem Haus-Film leer und beige ("sieht nicht schoen aus"). Waehrend
   der Film laeuft, fuellt sie jetzt (nur Handy im Hochformat, bis 760 px) eine weichgezeichnete Fortsetzung desselben
   Films: dieselbe Technik wie der unscharfe Intro-Hintergrund (eine Leinwand, auf die der Film gezeichnet wird, kein
   zweiter Download; etwa 20 Bilder pro Sekunde, endet mit dem Film), nach unten gespiegelt, damit der Boden nahtlos
   weiterlaeuft; darueber ein kurzer Text und eine feine Linie, die mit dem Film voll laeuft. Sobald die Bar da ist
   (xh-in), blendet die Flaeche in Buehne, Nummern und Duft ueber und wird entfernt.
   Film, Bildausschnitt, Ablauf und Timing bleiben unveraendert (Owner-Vorrang). Laeuft kein Film (Standbild, Datensparen,
   Bewegung reduzieren, "Eintreten" vor dem Tippen), erscheint nichts. CSS: lodar-v18-home.css, Block "v24 Haus-Fuellung". */
(function(){
  var hero = document.querySelector('.x-hero'), stage = document.getElementById('stageWrap'), v = hero ? hero.querySelector('.xh-room') : null;
  if(!hero || !stage || !v || !window.matchMedia || !document.documentElement.classList.contains('ed')) return;
  var mq = window.matchMedia('(max-width:760px) and (orientation:portrait)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var OV = 48, STEP = 50;   /* weicher Uebergang: 48 px ueber dem unteren Filmrand; Leinwand hoechstens alle 50 ms (20 Bilder/s) */
  var fill = null, cv = null, cx = null, bar = null, raf = 0, last = 0, lastT = -1, top0 = 0, done = false, guard = 0, fullT = 0;
  function film(){ var c = hero.classList; return c.contains('xh-play') && !c.contains('xh-in') && !c.contains('xh-tap') && !c.contains('xh-static'); }
  function paint(){ if(cx) try{ cx.drawImage(v, 0, 0, cv.width, cv.height); }catch(e){} }
  function prog(){
    if(!bar || reduce) return;
    var d = v.duration;
    if(d && isFinite(d)) bar.style.transform = 'scaleX(' + Math.min(1, Math.max(0, v.currentTime / d)).toFixed(4) + ')';
  }
  /* Lage: oben 48 px ueber dem unteren Filmrand, unten bis zum Ende von Hero und Bildschirm; der Text steht in der Mitte
     des sichtbaren Teils (--ed-hf-vis). Die Hoehe bleibt beim Ueberblenden gleich (kein Springen des weichen Bildes). */
  function place(){
    if(!fill) return;
    var hr = hero.getBoundingClientRect(), sr = stage.getBoundingClientRect(), y = sr.bottom - OV;
    top0 = Math.round(y - hr.top);
    var vis = Math.max(120, Math.round(Math.min(window.innerHeight, hr.bottom) - y));
    fill.style.top = top0 + 'px';
    fill.style.height = Math.max(vis, Math.round(window.innerHeight - y), Math.round(hr.height - top0)) + 'px';
    fill.style.setProperty('--ed-hf-vis', vis + 'px');
  }
  function loop(now){
    raf = 0;
    if(!fill || done) return;
    prog();
    if(now - last >= STEP && v.currentTime !== lastT){ last = now; lastT = v.currentTime; paint(); }
    if(!v.paused && !v.ended) raf = requestAnimationFrame(loop);
  }
  function run(){ if(fill && !done && !raf) raf = requestAnimationFrame(loop); }
  function stop(){ if(raf){ cancelAnimationFrame(raf); raf = 0; } }
  function build(){
    var el = document.createElement('div');
    el.className = 'ed-hf'; el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<canvas class="ed-hf-bg"></canvas><div class="ed-hf-veil"></div>' +
      '<div class="ed-hf-txt"><p class="ed-hf-k">Live-Perfumebar</p><p class="ed-hf-h">Erlebt die Bar live\u00a0\u2013 auch auf dem Handy.</p>' +
      '<p class="ed-hf-l">Gleich w\u00e4hlt ihr eure D\u00fcfte und f\u00fcllt sie ab.</p><span class="ed-hf-bar"><i></i></span></div>';
    cv = el.querySelector('canvas');
    try{ cx = cv.getContext('2d'); }catch(e){ cx = null; }
    if(!cx) return false;
    /* kleine Leinwand genuegt: das Bild wird mit 26 px weichgezeichnet */
    cv.width = 192; cv.height = Math.max(2, Math.round(192 * (v.videoHeight || 720) / (v.videoWidth || 1280)));
    bar = el.querySelector('.ed-hf-bar i');
    fill = el;
    hero.appendChild(fill);
    if(window.LODAR_I18N_ADD) window.LODAR_I18N_ADD(fill);
    return true;
  }
  function show(){
    if(fill || done || !film() || !mq.matches) return;
    if(!build()) return;
    place(); paint(); prog();
    hero.classList.add('ed-fill');
    void fill.offsetWidth;
    hero.classList.add('ed-fill-on');
    /* ist die Flaeche ganz da, braucht der Film seine blasse Spiegelung nicht mehr (spart dem Handy eine Ebene) */
    fullT = setTimeout(function(){ if(fill && !done) hero.classList.add('ed-fill-full'); }, 800);
    run();
    /* Sicherung: die Flaeche bleibt nie stehen (der Haus-Film geht spaetestens nach 20 s ins Haus) */
    guard = setTimeout(out, 25000);
  }
  /* ohne sichtbaren Film (z. B. "Eintreten" nach einem Fehler): sofort weg, ohne Ueberblenden */
  function drop(){
    stop(); clearTimeout(fullT); clearTimeout(guard);
    if(fill && fill.parentNode) fill.parentNode.removeChild(fill);
    fill = null; cx = null;
    hero.classList.remove('ed-fill', 'ed-fill-on', 'ed-fill-full', 'ed-fill-out');
  }
  /* die Bar ist da: Ueberblenden in Buehne, Nummern und Duft; die Flaeche folgt dabei dem unteren Rand der Buehne */
  function out(){
    if(done) return; done = true;
    stop(); clearTimeout(fullT); clearTimeout(guard);
    if(!fill) return;
    paint();
    if(bar && !reduce) bar.style.transform = 'scaleX(1)';
    hero.classList.add('ed-fill-out');
    var t0 = Date.now();
    (function follow(){
      if(!fill) return;
      var hr = hero.getBoundingClientRect(), sr = stage.getBoundingClientRect();
      fill.style.transform = 'translateY(' + Math.round(sr.bottom - hr.top - OV - top0) + 'px)';
      if(Date.now() - t0 < 1100) requestAnimationFrame(follow);
    })();
    setTimeout(drop, 1300);
  }
  v.addEventListener('playing', function(){ if(fill) run(); else show(); });
  v.addEventListener('seeked', function(){ if(fill && !done){ paint(); prog(); } });
  v.addEventListener('ended', function(){ if(fill && !done){ paint(); prog(); } });
  window.addEventListener('resize', function(){ if(fill && !done) place(); });
  if(window.MutationObserver) new MutationObserver(function(){
    var c = hero.classList;
    if(c.contains('xh-in')) out();
    else if(fill && !done && c.contains('xh-tap')) drop();
  }).observe(hero, {attributes: true, attributeFilter: ['class']});
})();

}catch(e){console.error("[v24 Haus-Fuellung]",e)}
;
/* ==== loader (replaces lodar-x3p.js; lodar-v18-x3d.js is lodar-x3d.js with the 14 x3p patches applied) ==== */
(function(){var u=window.LODAR_X3D;if(!u)return;var s=document.createElement('script');s.src=u;document.body.appendChild(s);})();
